import { ReactNode } from "react";
import { cn } from "../../lib/utils";

type Props = {
  children: ReactNode;
  className?: string;
};

export const TypographyP = ({ children, className, ...props }: Props) => {
  return (
    <p
      className={cn(
        "leading-7 text-brand-gray-900 dark:text-brand-gray-100",
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
};
